/**
 * Proctor test name for structured (vs. legacy string) location validation.
 *
 * The test gates which validator the LocationInputComponent uses for a
 * `PrefillLocation`: the structured `ValidateLocationData` GraphQL path when
 * enabled, or the legacy `ValidateStringLocation` path when in control.
 *
 */
export const STRUCTURED_LOCATION_VALIDATION_TEST_NAME =
    'jso_structured_location_validation_tst';

export const STRUCTURED_VALIDATION_BUCKET = 1;

/**
 * Accepts the allocated bucket value plus the raw `proctorGroups` string
 * exposed and returns whether structured validation is enabled
 */
export function isStructuredLocationValidationEnabled(
    bucketValue: number | undefined,
    proctorGroups: string | null | undefined,
): boolean {
    if (bucketValue === STRUCTURED_VALIDATION_BUCKET) return true;
    const overrideToken = `${STRUCTURED_LOCATION_VALIDATION_TEST_NAME}${STRUCTURED_VALIDATION_BUCKET}`;
    return proctorGroups?.includes(overrideToken) ?? false;
}
